<template>
  <div v-loading="usersFetchInProgress" class="event-users-editor">
    <el-pagination
      v-if="allUsers.length > pageSize"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size="pageSize"
      :total="allUsers.length"
    />

    <el-table
      :data="users"
      empty-text="Please add some users using button below"
    >
      <el-table-column label="E-mail" prop="email">
        <template slot-scope="{ row }">
          {{ row.email }}
          <CopyClick :text="row.email">
            <i class="ion ion-magnet margin-left-10 text-muted"></i>
          </CopyClick>
        </template>
      </el-table-column>
      <el-table-column label="Invited at" prop="invited_at">
        <template slot-scope="{ row }">
          <span v-if="row.invited_at">
            {{ row.invited_at | date('Y-MM-DD HH:mm') }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Status">
        <template slot-scope="{ row }">
          <span v-if="row.activated_at"
            >Activated at {{ row.activated_at | date('Y-MM-DD HH:mm') }}</span
          >
          <span v-else>Inactive</span>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="120">
        <template slot-scope="{ row }">
          <CopyClick
            tooltip-text="Click to copy activation link"
            :text="row.activation_link"
          >
            <a href class="btn btn-primary btn-xs" @click.prevent>
              <i class="ion ion-link"></i>
            </a>
          </CopyClick>
          <el-tooltip content="Send invitation e-mail" placement="top">
            <a
              href
              class="btn btn-primary btn-xs"
              @click.prevent="sendInvite({ user: row })"
            >
              <i class="ion ion-paper-airplane"></i>
            </a>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <a
              href
              class="btn btn-danger btn-xs"
              @click.prevent="removeUser({ user: row })"
            >
              <i class="ion ion-trash-b"></i>
            </a>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="allUsers.length > pageSize"
      class="margin-top-20"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size="pageSize"
      :total="allUsers.length"
    />

    <br />

    <el-button type="primary" @click="$refs.addUsersDialog.open()">
      Add
    </el-button>

    <el-button @click="$refs.massInviteDialog.open()">
      Mass invite
    </el-button>

    <el-button @click.prevent="downloadExcelUserList()">
      <i class="ion ion-android-download"></i>
      Download excel
    </el-button>

    <EventUsersAddDialog
      ref="addUsersDialog"
      :event="event"
      @add="onAdded($event)"
    />

    <EventUsersMassInviteDialog
      ref="massInviteDialog"
      :users="allUsers"
      @invited="fetch"
    />
  </div>
</template>

<script>
import EventUsersAddDialog from './EventUsersAddDialog.vue'
import EventUsersMassInviteDialog from './EventUsersMassInviteDialog.vue'
import CopyClick from 'components/CopyClick.vue'
import http from 'services/http'
import { mapState } from 'vuex'

export default {
  components: { CopyClick, EventUsersAddDialog, EventUsersMassInviteDialog },
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    users() {
      const idx = (this.page - 1) * this.pageSize
      return this.allUsers.slice(idx, idx + this.pageSize)
    },
    ...mapState({
      allUsers: (s) => s.eventDetails.users,
      usersFetchInProgress: (s) => s.eventDetails.usersFetchInProgress,
    }),
  },
  data() {
    return {
      page: 1,
      pageSize: 24,
    }
  },
  methods: {
    onAdded(applications) {
      this.$notify({
        type: 'success',
        title: 'Success',
        message: 'Investors added',
      })
      this.fetch()
    },

    fetch() {
      this.$store.dispatch('eventDetails/fetchUsers', {
        eventId: this.event.id,
      })
    },

    async sendInvite({ user }) {
      try {
        await this.$store.dispatch('eventDetails/sendInvite', {
          userId: user.id,
        })
        this.fetch()
        this.$notify({
          type: 'success',
          title: 'Success',
          message: 'Invitation has been sent',
        })
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Something went wrong',
        })
      }
    },

    async removeUser({ user }) {
      await this.$store.dispatch('eventDetails/removeUser', {
        email: user.email,
      })
      this.$notify({
        type: 'success',
        title: 'Success',
        message: 'Investor has been removed',
      })
    },

    async downloadExcelUserList() {
      const eventId = this.event.id
      http.downloadFile(`/events/${eventId}/users.xlsx`, 'investors.xlsx')
    },
  },
}
</script>

<style lang="scss">
.event-users-editor {
  .el-table__row {
    .ion-magnet {
      display: none;
    }
    &:hover {
      .ion-magnet {
        display: inline;
      }
    }
  }
}
</style>
